import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;

    ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
  }

  #root {
    min-height: 100vh;
  }

  /* Padronização de labels de inputs em todo o sistema */
  label {
    font-size: 12px !important;
    font-weight: 700 !important;
    font-family: 'Inter', sans-serif !important;
    color: #333333 !important;
  }

  /* Padronização de Inputs e Selects em todo o sistema */
  input[type="text"]:not(.inline-input),
  input[type="number"]:not(.inline-input),
  input[type="date"]:not(.inline-date),
  input[type="email"]:not(.inline-input),
  input[type="password"]:not(.inline-input),
  input[type="tel"]:not(.inline-input),
  input[type="url"]:not(.inline-input),
  input[type="search"]:not(.inline-input),
  select:not(.inline-input):not(.custom-select) {
    height: 38px !important;
    padding: 8px 16px !important;
    font-size: 12px !important;
    line-height: 20px !important;
    border-radius: 20px !important;
    background-color: #EBEBEB !important;
    border: 1px solid transparent !important;
    color: #696969 !important;
    font-family: 'Inter', sans-serif !important;
    outline: none !important;
    box-sizing: border-box !important;
    display: block;
    width: 100%;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out !important;
  }

  .inline-input,
  .inline-date {
    height: 32px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    box-sizing: border-box !important;
    font-size: 12px !important;
    line-height: 30px !important;
  }

  input[type="date"].inline-date::-webkit-calendar-picker-indicator {
    margin: 0 !important;
    padding: 0 !important;
    cursor: pointer;
  }

  input[type="date"].inline-date::-webkit-datetime-edit {
    padding: 0 !important;
  }

  /* Estados de Hover e Focus consistentes com o InfiniteSelect */
  input[type="text"]:hover:not(:disabled):not(.inline-input),
  input[type="number"]:hover:not(:disabled):not(.inline-input),
  input[type="date"]:hover:not(:disabled):not(.inline-date),
  input[type="email"]:hover:not(:disabled):not(.inline-input),
  input[type="password"]:hover:not(:disabled):not(.inline-input),
  input[type="tel"]:hover:not(:disabled):not(.inline-input),
  input[type="url"]:hover:not(:disabled):not(.inline-input),
  input[type="search"]:hover:not(:disabled):not(.inline-input),
  select:hover:not(:disabled):not(.inline-input):not(.custom-select) {
    border: 1px solid #cbd5e0 !important;
  }

  input[type="text"]:focus:not(.inline-input),
  input[type="number"]:focus:not(.inline-input),
  input[type="date"]:focus:not(.inline-date),
  input[type="email"]:focus:not(.inline-input),
  input[type="password"]:focus:not(.inline-input),
  input[type="tel"]:focus:not(.inline-input),
  input[type="url"]:focus:not(.inline-input),
  input[type="search"]:focus:not(.inline-input),
  select:focus:not(.inline-input):not(.custom-select) {
    border: 1px solid #3182ce !important;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1) !important;
  }

  /* Customização de selects para remover seta nativa do browser e alinhar com o design padrão */
  select {
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23696969' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 12px center !important;
    background-size: 12px !important;
    padding-right: 32px !important;
    cursor: pointer;
  }

  /* Alinhamento para input de data */
  input[type="date"] {
    position: relative;
    padding-right: 16px !important;
  }

  /* Input de arquivo e botões dentro de inputs */
  input:disabled,
  select:disabled {
    background-color: #D3D3D3 !important;
    cursor: not-allowed !important;
  }
`

// Tamanhos de tela com base em breakpoints comumente usados
export const sizes = {
  largeDesktop: 1400,
  smallDesktop: 1380,
  desktop: 992,
  tablet: 768,
  phone: 576,
}

// Media queries para cada tamanho de tela
export const devices = {
  largeDesktop: `(min-width: ${sizes.largeDesktop}px)`,
  desktop: `(min-width: ${sizes.desktop}px) and (max-width: ${
    sizes.largeDesktop - 1
  }px)`,
  smallDesktop: `(min-width: ${sizes.smallDesktop}px) and (max-width: ${
    sizes.desktop - 1
  }px)`,
  tablet: `(min-width: ${sizes.tablet}px) and (max-width: ${
    sizes.desktop - 1
  }px)`,
  phone: `(max-width: ${sizes.phone - 1}px)`,
}
